import { connect } from 'react-redux'
import { makeConditionSelector } from 'selectors/feature/conditions'
import { setConditionField } from 'actions/feature/conditions'

import { INPUT, NATIVE_BOOL, NATIVE_NON_BOOL } from 'utils/constants'
import { getOutputConfigAssessment } from 'selectors/feature/outputs'
import OperatorEditor from '../OperatorEditor'

const makeMapStateToProps = () => {
  const conditionSelector = makeConditionSelector()

  return (state, ownProps) => {
    const { uri, fnId } = ownProps
    const outputConfig = getOutputConfigAssessment(state, { id: fnId })
    const { operator, translationType, parentQueryUri } = conditionSelector(
      state,
      {
        queryUri: uri,
      }
    )
    const hasParent = parentQueryUri !== undefined && parentQueryUri !== ''
    return {
      equalsOnly:
        !hasParent &&
        (outputConfig === NATIVE_BOOL || outputConfig === NATIVE_NON_BOOL),
      operator,
      translationType,
      operatorType: INPUT,
    }
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const { uri } = ownProps

  return {
    onOperatorChange: (event) => {
      dispatch(setConditionField(uri, 'operator', event.target.value))
    },
  }
}

const InputOperatorEditorContainer = connect(
  makeMapStateToProps,
  mapDispatchToProps
)(OperatorEditor)

export default InputOperatorEditorContainer
